import { Rest } from './rest';

const headers = ({ token }) => ({ Authorization: `Bearer ${token}` });
const Feedback = new Rest(process.env.REACT_APP_FEEDBACK, headers);

export default Feedback;